import { useParams } from "react-router-dom";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import useGetUrlParams from "./useGetUrlParams";
import { getFareOffersWithDetails } from "../store/brandedFareOffers/selectors";
import { getFlight } from "../store/flightDetails/selectors";
import { goal } from "@flights/et-universal";

const useTrackFlightDetailsBrandedFaresGoals = () => {
  const { getUrlParam } = useGetUrlParams();
  const { id: token } = useParams<{ id: string }>();
  const flight = useSelector(getFlight);
  const fareOffersWithDetails = useSelector(getFareOffersWithDetails);
  const baseOfferToken = getUrlParam("baseOfferToken");

  let brandedFares = fareOffersWithDetails[baseOfferToken || token]?.brandedFareOffers;

  // In case branded fares on search weren't fetched yet, we can still detect this as a branded fare after the flight loads
  if (!brandedFares && flight?.token === token) {
    brandedFares = flight?.brandedFareOffers;
  }

  useEffect(() => {
    if (!brandedFares || brandedFares.length === 0) return;

    goal("flights_branded_fare_flight_detail_page_view");

    const fareIndex = brandedFares.findIndex((offer) => offer.token === token);

    if (fareIndex > 0) {
      goal("flights_branded_fare_upsell_flight_detail_page_view");
    }
  }, [brandedFares, token]);
};

export default useTrackFlightDetailsBrandedFaresGoals;
